import React, { useState, useEffect } from "react";

const UpdateInternAmount = () => {
  const [config, setConfig] = useState(null);

  const [internId, setInternId] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [updateError, setUpdateError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const [intern, setIntern] = useState(null);
  const [amount, setAmount] = useState("");

  // 1) Load config
  useEffect(() => {
    fetch("/config.json")
      .then((r) => r.json())
      .then(setConfig)
      .catch(() => setFetchError("Failed to load config.json"));
  }, []);

  // 2) Fetch details by intern_id
  const handleFetch = async (e) => {
    e.preventDefault();
    setFetchError("");
    setSuccessMsg("");
    setUpdateError("");
    setIntern(null);

    if (!internId.trim()) {
      setFetchError("Please enter an Intern ID.");
      return;
    }
    if (!config) return;

    try {
      setLoading(true);
      const res = await fetch(
        `${config.BASE_URL}${config.FETCH_INTERN_BY_ID}`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ intern_id: internId.trim() }),
        }
      );

      const data = await res.json();
      if (!data.success || !data.intern) {
        setFetchError(data.message || "No intern found for this ID.");
        setIntern(null);
      } else {
        setIntern(data.intern);
        setAmount(
          data.intern.amount !== null && data.intern.amount !== undefined
            ? String(data.intern.amount)
            : ""
        );
      }
    } catch (err) {
      setFetchError("Failed to fetch intern details.");
    } finally {
      setLoading(false);
    }
  };

  // 3) Update amount
  const handleUpdate = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setUpdateError("");

    if (!intern) {
      setUpdateError("Fetch an intern first.");
      return;
    }

    const numeric = Number(amount);
    if (!amount || Number.isNaN(numeric) || numeric <= 0) {
      setUpdateError("Please enter a valid amount (greater than 0).");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(
        `${config.BASE_URL}${config.UPDATE_INTERN_AMOUNT}`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            intern_id: intern.intern_id,
            amount: Number.parseFloat(numeric.toFixed(2)), 
          }),
        }
      );

      const data = await res.json();
      if (data.success) {
        setSuccessMsg("Amount updated successfully!");
        // reflect in UI
        setIntern((prev) => (prev ? { ...prev, amount: numeric } : prev));
      } else {
        setUpdateError(data.message || "Failed to update amount.");
      }
    } catch (err) {
      setUpdateError("Error updating amount.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update-intern-amount" style={{ maxWidth: 720, margin: "20px auto", padding: 16, background: "#fff", borderRadius: 8, boxShadow: "0 2px 10px rgba(0,0,0,0.08)" }}>
      <h2 style={{ marginBottom: 16 }}>Update Intern Amount</h2>

      {/* Fetch form */}
      <form onSubmit={handleFetch} style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <input
          type="text"
          placeholder="Enter Intern ID"
          value={internId}
          onChange={(e) => setInternId(e.target.value)}
          style={{ flex: 1, padding: 10, border: "1px solid #ddd", borderRadius: 6 }}
        />
        <button
          type="submit"
          disabled={loading || !config}
          style={{ padding: "10px 16px", border: "none", background: "#0a7cff", color: "#fff", borderRadius: 6, cursor: "pointer" }}
        >
          {loading ? "Fetching..." : "Fetch Details"}
        </button>
      </form>

      {fetchError && <div style={{ color: "#b00020", marginBottom: 12 }}>{fetchError}</div>}

      {/* Intern details */}
      {intern && (
        <div style={{ border: "1px solid #eee", borderRadius: 8, padding: 12, marginBottom: 16 }}>
          <h3 style={{ marginTop: 0, marginBottom: 10 }}>Intern Details</h3>
          <div style={{ display: "grid", gridTemplateColumns: "160px 1fr", rowGap: 8 }}>
            <div style={{ color: "#666" }}>Intern ID</div><div>{intern.intern_id}</div>
            <div style={{ color: "#666" }}>Name</div><div>{intern.name}</div>
            <div style={{ color: "#666" }}>Email</div><div>{intern.email}</div>
            <div style={{ color: "#666" }}>Phone</div><div>{intern.phone}</div>
            <div style={{ color: "#666" }}>Domain</div><div>{intern.domain}</div>
            <div style={{ color: "#666" }}>College</div><div>{intern.college}</div>
            <div style={{ color: "#666" }}>CGPA</div><div>{intern.cgpa}</div>
            <div style={{ color: "#666" }}>Current Amount</div><div>{intern.amount ?? "-"}</div>
            <div style={{ color: "#666" }}>Status</div><div>{intern.status === 1 ? "Approved" : intern.status === 0 ? "Pending" : intern.status}</div>
          </div>
        </div>
      )}

      {/* Update amount form */}
      {intern && (
        <form onSubmit={handleUpdate} style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <input
            type="number"
            step="0.01"
            min="0"
            placeholder="Enter new amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            style={{ flex: 1, padding: 10, border: "1px solid #ddd", borderRadius: 6 }}
          />
          <button
            type="submit"
            disabled={loading || !config}
            style={{ padding: "10px 16px", border: "none", background: "#27ae60", color: "#fff", borderRadius: 6, cursor: "pointer" }}
          >
            {loading ? "Saving..." : "Update Amount"}
          </button>
        </form>
      )}

      {updateError && <div style={{ color: "#b00020", marginTop: 12 }}>{updateError}</div>}
      {successMsg && <div style={{ color: "#2e7d32", marginTop: 12 }}>{successMsg}</div>}
    </div>
  );
};

export default UpdateInternAmount;
